import Caption from 'LuxKit/Typography/Caption'
import React from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  departureCity?: string
  destinationCity?: string
}

export function HeroCruiseLocation({ destinationCity, departureCity }: Props) {
  return (
    <Caption variant="large" colour="neutral-one">
      {departureCity === destinationCity && <FormattedMessage
        id="oSCcDGA97N"
        defaultMessage="Starts and ends in <b>{departureCity}</b>"
        description="Label for cruise that departs and returns to the same city, with the city name in bold"
        values={{
          departureCity,
          b: (chunks) => <b>{chunks}</b>,
        }}
      />}
      {departureCity !== destinationCity && <FormattedMessage
        id="SjfwU+O5N6"
        defaultMessage="Starts in <b>{departureCity}</b>. Ends in <b>{destinationCity}</b>"
        description="Label for cruise with different departure and destination cities, with city names in bold"
        values={{
          departureCity,
          destinationCity,
          b: (chunks) => <b>{chunks}</b>,
        }}
      />}
    </Caption>
  )
}
